import { Station } from '@mi-front/core';
import { isVideoStation } from '../helpers';
import { useStations } from './useStations';

export function useVideoStations(): readonly Station[] {
  return useStations(isVideoStation);
}
